"use strict";
/*
*+------------------------------------------------------------------------+
*| Licensed Materials - Property of IBM
*| IBM Cognos Products: Dashboard
*| (C) Copyright IBM Corp. 2020
*|
*| US Government Users Restricted Rights - Use, duplication or disclosure
*| restricted by GSA ADP Schedule Contract with IBM Corp.
*+------------------------------------------------------------------------+
*/

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

require("./conditionalFormatScaleComponent.scss");

var ConditionalFormatScaleComponent =
/** @class */
function (_super) {
  __extends(ConditionalFormatScaleComponent, _super);

  function ConditionalFormatScaleComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ConditionalFormatScaleComponent.prototype.render = function () {
    var conditionalFormatModel = this.props.conditionalFormatModel;
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      className: 'vis-cf-conditionalFormatScaleFlexbox'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingScale')
    })), react_1.default.createElement(ca_ui_toolkit_1.Select, {
      id: 'select-list',
      selected: conditionalFormatModel.getScale(),
      onChange: function onChange(value) {
        conditionalFormatModel.setScale(value);
      },
      options: [{
        value: '%',
        label: StringResources_1.default.get('conditionalFormattingPercentage')
      }, {
        value: '#',
        label: StringResources_1.default.get('conditionalFormattingNumeric')
      }],
      className: 'vis-cf-conditionalFormatScaleSelectBox'
    }));
  };

  return ConditionalFormatScaleComponent;
}(react_1.Component);

exports.default = mobx_react_1.observer(ConditionalFormatScaleComponent);
